import React from 'react'

import SelectWithSearch, {SelectOption} from './SelectWithSearch'

interface BloodGroupSelectProps {
  onSelect: (bloodGroup: string) => void
  selectedValue?: string | null
  theme?: 'light' | 'dark'
}

const BLOOD_GROUPS: SelectOption[] = [
  {label: 'A+', value: 'A+', icon: '🩸'},
  {label: 'A-', value: 'A-', icon: '🩸'},
  {label: 'B+', value: 'B+', icon: '🩸'},
  {label: 'B-', value: 'B-', icon: '🩸'},
  {label: 'AB+', value: 'AB+', icon: '🩸'},
  {label: 'AB-', value: 'AB-', icon: '🩸'},
  {label: 'O+', value: 'O+', icon: '🩸'},
  {label: 'O-', value: 'O-', icon: '🩸'},
]

const BloodGroupSelect: React.FC<BloodGroupSelectProps> = ({
  onSelect,
  selectedValue,
  theme = 'light',
}) => {
  return (
    <SelectWithSearch
      options={BLOOD_GROUPS}
      onSelect={onSelect}
      selectedValue={selectedValue}
      theme={theme}
      placeholder='Search for your blood group...'
      emptyMessage='No blood groups found'
    />
  )
}

export default BloodGroupSelect
